const defaultPassword = '12345';
const timePasswordExpiry = 86400000;
const pandoConsigneeAppUrl = 'https://play.google.com/store/apps/details?id=com.pando.consignee.parcel';
const consigneeConstants = {
    validConsigneeHeaders: {
        'Consignee Name*': 'company_name',
        'Reference Id*': 'ref_id',
        'Contact Name': 'rname',
        'Mobile Number': 'rmobile',
        Email: 'remail',
        Address: 'address',
        'City*': 'city',
        'State*': 'state',
        'Postal Code*': 'pincode',
        'Region*': 'region',
        Category: 'category',
        'Display Reference Name': 'display_reference_name',
    },
    exportAndRejectionHeaders: {
        'Consignee Name*': 'company_name',
        'Reference Id*': 'ref_id',
        'Contact Name': 'rname',
        'Mobile Number': 'rmobile',
        Email: 'remail',
        Address: 'address',
        'City*': 'city',
        'State*': 'state',
        'Postal Code*': 'pincode',
        'Region*': 'region',
        Category: 'category',
        'Ports Associated': 'ports_associated',
        'Overseas Customer': 'overseas_customer',
        Country: 'country',
        'Combine delivery with other consignees': 'combine',
        'Customer Type': 'customer_type',
    },
    validOptionalConsigneeHeaders: {
        Group: 'group',
        'Sales Contact Name': 'sales_name',
        'Sales Contact Mobile Number': 'sales_mobile',
        'Sales Contact Email': 'sales_email',
        'De-couple deliveries': 'delivery_do_not_combine',
        'Combine delivery with other consignees': 'combine',
        'Ports Associated': 'ports_associated',
        'Overseas Customer': 'overseas_customer',
        'Customer Logistics Leader(EMAIL ID)': 'customer_logistic_leader',
        Country: 'country',
        'Display Reference Name': 'display_reference_name',
        Status: 'status',
        'Epod Group': 'epod_group',
        'Courier Ref Id' : 'courier_ref_id',
        'Customer Type': 'customer_type',
        // 'Loading start time (HH:MM)': 'loading_start_time',
        // 'Loading end time (HH:MM)': 'loading_end_time',
        // 'Unloading start time (HH:MM)': 'unloading_start_time',
        // 'Unloading end time (HH:MM)': 'unloading_end_time',
    },
    consigneeNonMandatoryHeaders: {
        'Reference ID': 'reference_id',
        'Exclude Vehicle Type': 'exclude_vehicle_type',
        'Optima Category': 'optima_category',
    },
    consigneeType: {
        SHIPPER: 1,
        CUSTOMER: 2,
        COMAKER: 3,
        HUB: 4,
    },
    movementConsigneeType: {
        PRIMARY: 1,
        SECONDARY: 2,
        COMAKER: 3,
    },
    validationErrorMessage: {
        name: 'Consignee Name should not be empty',
        reference: 'Reference Id should not be empty',
        city: 'City should not be empty',
        state: 'State should not be empty',
        pincode: 'Postal Code should not be empty',
        reference_not_exist: 'Reference Id not exist',
        vehicle_not_exist: 'Vehicle type not exist',
        pincode_alphanumeric: 'Postal Code must be valid and should not be empty',
    },
    consigneeTypeValues: {
        SHIPPER: 'Shipper Site',
        CUSTOMER: 'Customer Site',
    },
    dispatchScheduleHeaders: {
        'Dispatch Schedule Monday  (YES/NO)': 'dispatch_schedule_monday',
        'Dispatch Schedule Tuesday (YES/NO)': 'dispatch_schedule_tuesday',
        'Dispatch Schedule Wednesday (YES/NO)': 'dispatch_schedule_wednesday',
        'Dispatch Schedule Thursday (YES/NO)': 'dispatch_schedule_thursday',
        'Dispatch Schedule Friday (YES/NO)': 'dispatch_schedule_friday',
        'Dispatch Schedule Saturday (YES/NO)': 'dispatch_schedule_saturday',
        'Dispatch Schedule Sunday (YES/NO)': 'dispatch_schedule_sunday',
    },
    dispatchSchedule: {
        'Dispatch Schedule Monday': 'monday',
        'Dispatch Schedule Tuesday': 'tuesday',
        'Dispatch Schedule wednesday': 'wednesday',
        'Dispatch Schedule Thurday': 'thursday',
        'Dispatch Schedule friday': 'friday',
        'Dispatch Schedule Saturday': 'saturday',
        'Dispatch Schedule Sunday': 'sunday'
    },
};
const customerTypes = {
    'DISTRIBUTOR': 'distributor',
    'ONE_TIME_CUSTOMER': 'one time customer',
    'CUSTOMER_SITE': 'customer site'
}

const customerDetails = {
    'Customer Name': 'company_name',
    'Customer Reference Id': 'ref_id',
    'Customer Contact Name': 'rname',
    'Customer Address': 'address',
    'Customer City': 'city',
    'Customer State': 'state',
    'Customer Pincode': 'pincode',
    'Customer Region': 'region',
    'Customer Mobile Number': 'rmobile',
    'Customer Email': 'remail',
    'Customer Type': 'customer_type',
    'Customer Category': 'customer_category',
    'Customer De-couple deliveries': 'delivery_do_not_combine',
    'Combine delivery with other consignees': 'combine',
  };

  const erpCustomerDetails = {
    customer_name: 'company_name',
    customer_ref_id: 'ref_id',
    customer_rname: 'rname',
    customer_address: 'address',
    customer_city: 'city',
    customer_state: 'state',
    customer_pincode: 'pincode',
    customer_region: 'region',
    customer_rmobile: 'rmobile',
    customer_remail: 'remail',
    customer_type: 'customer_type',
    customer_category: 'customer_category',
    customer_delivery_do_not_combine: 'delivery_do_not_combine',
    customer_combine: 'combine',
  };

module.exports = { defaultPassword, pandoConsigneeAppUrl, timePasswordExpiry, consigneeConstants, customerTypes, customerDetails, erpCustomerDetails };
